import React, { useState } from 'react';

import moment from 'moment';
import { useTranslation } from 'react-i18next';

import { movedAllPositionData, useGetGanttDataQuery } from '@entities/gantt';
import { ganttQueueProcess } from '@entities/gantt/api/ganttQueueProcess';
import { CustomModal, Flex, UiButton, UiDateInput } from '@shared/ui';

import cls from './ShiftStartDateFormStep.module.css';

interface ShiftStartDateFormStepProps {
    handleClose: () => void;
    onChangeStatusInExploitation: () => Promise<void>;
}

export const ShiftStartDateFormStep = ({
    handleClose,
    onChangeStatusInExploitation,
}: ShiftStartDateFormStepProps) => {
    const [date, setDate] = useState('');

    const { t } = useTranslation();
    const { ganttData } = useGetGanttDataQuery();

    const onChangeDate = (value: string) => {
        setDate(value);
    };

    const onSubmit = async () => {
        const isoDate = moment(date, 'DD.MM.YYYY').toISOString();
        const positionsQueue = movedAllPositionData(isoDate, ganttData.data);
        await ganttQueueProcess(positionsQueue);
        await onChangeStatusInExploitation();
    };

    return (
        <>
            <CustomModal.Header classes={cls.header}>
                {t('ShiftStartDateFormStep.CustomModal.Header')}
            </CustomModal.Header>
            <CustomModal.Body>
                <UiDateInput
                    inputClassName={cls.input}
                    calendarIconClassNames={cls.calendarIconClassNames}
                    placeholder={t(
                        'ShiftStartDateFormStep.CustomModal.Body.UiDateInput.placeholder'
                    )}
                    value={date}
                    onChange={onChangeDate}
                />
            </CustomModal.Body>
            <CustomModal.Footer>
                <Flex gap={8} justify="between" fullWidth>
                    <UiButton
                        onClick={handleClose}
                        btnColor="secondary"
                        className={cls.buttons}
                        btnText={t('button.cancel.text')}
                    />
                    <UiButton
                        onClick={onSubmit}
                        disabled={!date}
                        className={cls.buttons}
                        btnText={t('ShiftStartDateFormStep.CustomModal.Body.UiButton.btnText')}
                    />
                </Flex>
            </CustomModal.Footer>
        </>
    );
};
